import React from 'react';

import type {Monster} from '../../../generated/types';
import {EntitySeo, pageTitle, withOriginal} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {monsterDescription, MonsterTab} from './monster-seo-text';

type Props = {
	monster: Monster;
	/** вкладка «Особенности» — блок параметров, «Описание» — лор, группа и логово */
	tab: MonsterTab;
	/** старая редакция, открытая как вариант: canonical ведёт на её адрес */
	variantId?: string;
};

export const MonsterSeo: React.FC<Props> = ({monster, tab, variantId}) => {
	const monsterPath = buildUrl('monster', {id: monster.id});

	if (tab === 'about') {
		const path = buildUrl('monsterInfo', {id: monster.id});
		return (
			<EntitySeo
				entity={monster}
				section="monsters"
				kind="чудовище из Бестиария"
				title={pageTitle(
					`${withOriginal(monster.title, monster.originalTitle)}: описание чудовища из Бестиария`,
				)}
				description={monsterDescription(monster, 'about')}
				path={path}
				og={{kind: 'monster'}}
				crumbs={[
					{name: monster.title, path: monsterPath},
					{name: 'Описание', path},
				]}
			/>
		);
	}

	return (
		<EntitySeo
			entity={monster}
			section="monsters"
			kind="чудовище из Бестиария"
			description={monsterDescription(monster)}
			path={variantId ? buildUrl('monsterVariant', {id: monster.id, variantId}) : monsterPath}
			og={{kind: 'monster'}}
		/>
	);
};
